import { isUnlimitedPlan } from '@smarty-nx/contentful'
import { ValueWithUnit } from '@smarty-nx/data'

import {
  DEFAULT_PLAN_RUNNING_LOW_THRESHOLD,
  PLAN_500_MB_DATA_SIZE,
  PLAN_500_MB_RUNNING_LOW_THRESHOLD,
  DATA_DISCOUNT_VALUE,
  PLAN_IDS,
} from '../constants'

// returns GB if greater than or equal to 1, MB if not
export const getDataUnit = (
  dataValue: number | null
): string | null | number => {
  if (dataValue) {
    return dataValue >= 1 ? 'GB' : 'MB'
  }

  return dataValue
}

// returns verbatim number if greater than or equal to 1, the MB value if not (GB * 1000)
export const getDataAllowance = (dataValue: number | null) => {
  if (dataValue) {
    return dataValue >= 1 ? dataValue : dataValue * 1000
  }

  return dataValue
}

/**
 * returns the full data allowance string with data and unit
 * helpful when we don't need to break the string down into various sized components
 * */
export const getFormattedDataAllowance = (dataValue?: number | null) => {
  if (dataValue) {
    return `${getDataAllowance(dataValue)}${getDataUnit(dataValue)}`
  }

  return ''
}

/**
 * This method checks if the plan is unlimited and returns the correct data format
 * */
export const getDataText = (dataInGb: number | null, id: string) => {
  if (isUnlimitedPlan(id)) {
    return 'Unlimited'
  } else if (dataInGb) {
    return `${dataInGb}${getDataUnit(dataInGb)}`
  }

  return ''
}

/**
 * This method checks if the plan is 4GB-data
 * We use this to control the 4gb asset colour (it uses teal instead of yellow)
 * */
export const isPlanFourGB = (id: string) => id === PLAN_IDS.SM_FOUR_GB_PLAN

/** returns the data discount for a plan */
export const returnDataDiscount = (dataInGb: number | null) => {
  if (!dataInGb) {
    return '£0.00'
  }
  return dataInGb >= 1
    ? `£${dataInGb * DATA_DISCOUNT_VALUE}`
    : `£${(dataInGb * DATA_DISCOUNT_VALUE).toFixed(2)}`
}

export const returnFormattedUsageData = (data: ValueWithUnit) =>
  `${data.value}${data.unit}`

export const isRunningLowOnData = (
  data: string | number | undefined,
  totalData: string | number | undefined,
  unit = 'MB'
) => {
  const lowDataThreshold =
    totalData === PLAN_500_MB_DATA_SIZE
      ? PLAN_500_MB_RUNNING_LOW_THRESHOLD
      : DEFAULT_PLAN_RUNNING_LOW_THRESHOLD
  return unit === 'MB' && Number(data) <= lowDataThreshold
}

export const moreThanGBAmount = (
  amount: number,
  unit?: string,
  value?: string | number
) => unit && value && unit === 'GB' && Number(value) > amount
